/* eslint-disable react/prop-types */
import React from 'react';
import Choices from './Choices';
import AgreedList from './AgreedList';
import Match from './Match';
import AdPosition from '../base/AdPosition';
import '~styles/modules/quiz.scss';

class Quiz extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      answers: [null, null, null, null, null, null, null, null, null, null, null,
        null, null, null, null, null, null, null, null, null, null, null],
    };
  }

  handleChange(ev) {
    const chosen = ev.currentTarget.value.split('a');
    // chosen is q01a1 chosen[0] is the q, chosen[1] is the answer
    chosen[0] = parseInt(chosen[0].replace('q', ''), 10) - 1;
    this.setState(
      (value) => {
        value.answers[chosen[0]] = `a${chosen[1]}`;
        return value;
      },
    );
  }

  render() {
    const {
      data, questions, candidates, smallimages, images,
    } = this.props;
    // sort question by id so it is in order
    questions.sort((a, b) => ((a.qid > b.qid) ? 1 : -1));

    const list = questions.map((question) => {
      const related = question.relatedurl ? (
        <a className="question__link bentoncond-n4" target="_blank" href={question.relatedurl} rel="noreferrer">
          Read more about this topic.
        </a>
      ) : '';

      return (
        <li className="question" key={question.qid} data-qid={question.qid} id={question.topic.split(' ').join('').toLowerCase()}>
          <div className="question__content">

            <h4 className="question__title bentoncond-n4">
              <span>&#8600;</span>
              {' '}
              {question.title}
            </h4>
            <h3 className="question__text miller-n6">
              {question.question}
              {' '}
              {related}
            </h3>
            <Choices
              qid={question.qid}
              a1={question.a1}
              a2={question.a2}
              a3={question.a3}
              a4={question.a4}
              handleChange={this.handleChange.bind(this)}
            />
          </div>
          <AgreedList
            candidates={candidates}
            qid={question.qid}
            images={smallimages}
            choice={this.state.answers}
          />
        </li>
      );
    });
    const ad1 = <li key="ad1"><AdPosition positionId="ad_inarticle1" /></li>;
    list.splice(9, 0, ad1);
    const ad2 = <li key="ad2"><AdPosition positionId="ad_inarticle2" /></li>;
    list.splice(19, 0, ad2);

    // click #show-results button to remove `hide` class from .match-results
    function toggleCheetMode(ev) {
      // console.log(ev.target.checked);
      if (ev.target.checked) {
        ev.currentTarget.closest('.quiz').classList.remove('noresults');
      } else {
        ev.currentTarget.closest('.quiz').classList.add('noresults');
      }
    }

    return (
      <div className="quiz noresults">
        <div className="cheatmode">
          <label className="cheatmode-label bentoncond-n4">
            Optional:
            {' '}
            <input className="checkbox cheatmode-check" type="checkbox" onChange={toggleCheetMode} />
            {' '}
            Reveal each candidate’s choice as you answer (cheat mode)
          </label>
        </div>
        <ul>{list}</ul>
        <Match
          data={data.quiz}
          candidates={candidates}
          images={images}
          questions={questions}
          answers={this.state.answers}
        />
      </div>
    );
  }
}

export default Quiz;
